export default __webpack_public_path__ + "static/media/saturn.beaf5bdb.png";